(function($) {
    class W4D_Favourites_Handler {
        constructor() {
            this.body = $('body');
            this.favCookieName = 'fav_cookie';
            this.productCards = $('.product-cards');
            this.offeringCarouselWrapper = $('.offering-carousel-wrapper');
            this.productCardFavouriteIcon = '.favourite';
            this.removeFavouriteIcon = $('.product-card__remove-btn');
            this.favouriteH1Counter = $('.wishlist__topbar .lg span')
            this.favouritesHeaderIcon = $('.header_favourites');
            this.removeAllFavouritesButton = $('#remove_all_favourites');
            this.productCardsWishlist = $('.product-cards.wishlist');
            this.productGalleryFavourite = $('.product-gallery__favorites');
            this.productShoppingCartFavourite = $('.woo-wrapper__product-ctas .product-favorites');

            this.init();
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            $(document).on('click', this.productCardFavouriteIcon, (e) => this.handleFavouriteClick(e));
            $(document).on('click', '.product-card__remove-btn', (e) => this.handleFavouriteClick(e));
            this.removeAllFavouritesButton.on('click', (e) => this.handleRemoveAllFavourites(e));
        }

        updateFavouritesIcon(favouritesCount) {
            this.favouritesHeaderIcon.attr('data-populated', favouritesCount);
            if (favouritesCount > 0) {
                this.favouritesHeaderIcon.addClass('w4d-header__btn--populated');

                // Add pulse animation
                this.favouritesHeaderIcon.removeClass('w4d-header__btn--adding');
                requestAnimationFrame(() => {
                    this.favouritesHeaderIcon.addClass('w4d-header__btn--adding');
                });

                // Remove animation class when animation ends
                this.favouritesHeaderIcon.one('animationend', () => {
                    this.favouritesHeaderIcon.removeClass('w4d-header__btn--adding');
                });

            } else {
                this.favouritesHeaderIcon.removeClass('w4d-header__btn--populated');
            }
        }

        handleRemoveAllFavourites(e) {
            e.preventDefault();
            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: {
                    action: 'remove_all_favourites',
                    nonce: w4d_frontend_ajax.nonce,
                },
                success: () => {
                    this.updateFavouritesIcon(0);

                    if (this.favouriteH1Counter) {
                        this.favouriteH1Counter.text('(0)');
                    }

                    this.productCardsWishlist.empty().append('<h3 class="uppercase clr-neutral-500" style="grid-column:1/5;">Trenutno nemate favorita</h3>');
                    this.removeAllFavouritesButton.remove();
                },
                error: () => {
                    alert('An error occurred. Please try again.');
                }
            });
        }

        handleFavouriteClick(e) {
            e.preventDefault();
            let isWishlistPage = this.body.hasClass('page-template-template-wishlist');

            const $favourite = $(e.currentTarget);

            const isLoggedIn = $('body').hasClass('logged-in');

            let productID = $favourite.data('product-id');

            if ($favourite.hasClass('favourite--active')) {
                $favourite.find('p').text('Dodaj u favorite');
            } else {
                $favourite.find('p').text('Ukloni iz favorita');
            }

            let ajaxData = {
                action: 'w4d_toggle_favourite',
                nonce: w4d_frontend_ajax.nonce,
                product_id: productID,
                current_page: window.location.pathname
            }

            if (isLoggedIn) {
                $.post({
                    url: w4d_frontend_ajax.ajax_url,
                    data: ajaxData,
                    success: (response) => {
                        this.handleLoggedInUserResponse(response, $favourite, isWishlistPage);
                    },
                    error: (response) => {
                        console.error(response);
                    }
                });
            } else {
                this.handleNonLoggedInUserFavouriteClick($favourite, productID, isWishlistPage);
            }
        }

        handleLoggedInUserResponse(response, $favourite, isWishlistPage) {
            if (response.data.status === 'added') {
                $favourite.toggleClass('favourite--active');
                $favourite.toggleClass('favourite--just-added');
            } else if (response.data.status === 'removed') {
                $favourite.removeClass('favourite--active');
                $favourite.removeClass('favourite--just-added');

                if (isWishlistPage) {
                    this.showEmptyFavouritesState($favourite, response.data.total_favorites);
                }
            }

            // Update Header Favourites with animation
            this.updateFavouritesIcon(response.data.total_favorites);
        }

        handleNonLoggedInUserFavouriteClick($favourite, productID, isWishlistPage) {
            let favCookie = W4D_FrontendHelper.getCookie(this.favCookieName);
            favCookie = favCookie ? JSON.parse(favCookie) : [];

            if (favCookie.includes(productID)) {
                favCookie = favCookie.filter(id => id !== productID);
                $favourite.removeClass('favourite--active');
                $favourite.removeClass('favourite--just-added');

                if (isWishlistPage) {
                    this.showEmptyFavouritesState($favourite, favCookie.length);
                }
            } else {
                $favourite.toggleClass('favourite--active');
                $favourite.toggleClass('favourite--just-added');

                favCookie.push(productID);
            }

            // Update Header Favourites with animation
            this.updateFavouritesIcon(favCookie.length);
            W4D_FrontendHelper.setCookie(this.favCookieName, JSON.stringify(favCookie), null, 'Lax');
        }

        showEmptyFavouritesState($favourite, favouritesCount) {
            $favourite.closest('.product-card').remove();

            if (favouritesCount < 1) {
                this.productCardsWishlist.empty().append('<h3 class="uppercase clr-neutral-500" style="grid-column:1/5;">Trenutno nemate favorita</h3>');
                this.removeAllFavouritesButton.remove();
            }

            this.favouriteH1Counter.text(`(${favouritesCount})`);
        }
    }

    $(document).ready(() => {
        new W4D_Favourites_Handler();
    });

})(jQuery);